<div class="row">
  <div class="col-12 text-center">
    <h3>{{ 'PRODUCT_EXPORT_CATEGORY_MAPPING' | translate | uppercase }}</h3>
  </div>
</div>
<lib-filter-list [configService]="configService"></lib-filter-list>
